module.exports = __webpack_public_path__ + "static/media/Component1.503b604c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Component1.svg
// module id = 148
// module chunks = 0